<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-flex lg6>
          <label class="blackLabel">* Token Name:</label>
          <v-text-field label="Name" v-model="tokenName" required :rules="nameRules" single-line solo></v-text-field>
        </v-flex>
        <v-flex lg6>
          <label class="blackLabel">Token Value:</label>
          <p>{{ globalModalParams.token.t_token }}</p>
        </v-flex>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" :disabled="!isAddValid" @click.stop="fncUpdateToken()">Update</v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Settings',
    data() {
      return {
        isAddValid: false,
        search: '',
        tokenId: '',
        tokenName: '',
        nameRules: [
          v => !!v || 'Token name is required',
        ]
      };
    },
    methods: {
      fncHideModal() {
        this.$store.commit('hideModal');
      },
      fncUpdateToken() {
        this.$store.dispatch({
          type: 'fncUpdateToken',
          tokenName: this.tokenName,
          tokenId: this.tokenId
        });
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'runAdd'
      ])
    },
    mounted() {
      this.tokenName = this.globalModalParams.token.t_description;
      this.tokenId = this.globalModalParams.token.t_id;


    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
